module.exports = __webpack_public_path__ + "img/_blog6.bcb97ce6.jpg";